import { useState } from "react";
import { toast } from "react-toastify";

const VoteDisplay = ({ candidate1, candidate2, VoteCandidate }) => {
  const [selectedCandidateId, setSelectedCandidateId] = useState(0);

  const handleSubmit = (e) => {
    if (Number(selectedCandidateId)) {
      VoteCandidate(Number(selectedCandidateId))
        .then((response) => {
          toast("Your vote has been successfully submited", {
            type: "success",
            autoClose: 20000,
          });
        })
        .catch((error) => {
          toast(error.message, { type: "error" });
        });
    } else toast("Please select a candidate ", { type: "error" });
  };

  if (!candidate1 || !candidate2)
    return <h1 className="text-center m-3">Loading...</h1>;
  return (
    <>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Candidate Name</th>
            <th scope="col">Vote Count</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">{candidate1.id}</th>
            <td>{candidate1.candidateName}</td>
            <td>{candidate1.voteCount}</td>
          </tr>
          <tr>
            <th scope="row">{candidate2.id}</th>
            <td>{candidate2.candidateName}</td>
            <td>{candidate2.voteCount}</td>
          </tr>
        </tbody>
      </table>

      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6">
          <select
            class="form-select"
            aria-label="Default select example"
            onChange={(e) => {
              setSelectedCandidateId(e.target.value);
            }}
          >
            <option value="0" selected>
              Select candidate
            </option>
            <option value="1">{candidate1.candidateName}</option>
            <option value="2">{candidate2.candidateName}</option>
          </select>
        </div>
        <div className="col-md-3"></div>
      </div>

      <br />
      <button
        type="button"
        class="btn btn-lg btn-secondary"
        onClick={(e) => {
          handleSubmit(e);
        }}
      >
        Vote
      </button>
    </>
  );
};

export default VoteDisplay;
